/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { TabGroupComponentDisplay } from "cms/components/components/tab-group/display";
import { TabGroupComponentEditor } from "cms/components/components/tab-group/edit/index";

function TabGroupComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <TabGroupComponentDisplay />,
        editComponent: <TabGroupComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

TabGroupComponent.displayName = "TabGroupComponent";
export { TabGroupComponent };
